export default __webpack_public_path__ + "static/WKV4C-3d6ad94848a72a96415d9a23e47132fc.png";